import { useMemo } from "react";
import useLayoutStore, { LeftTab } from "@/store/zustand/layoutStore";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

export const useLeftPanelShortcuts = () => {
  const setNewLayout = useLayoutStore((state) => state.setNewLayout);

  const shortcuts: ShortcutMap = useMemo(
    () => ({
      "alt+1": {
        handler: () => setNewLayout(LeftTab.DomTree),
        description: "Switch to Dom Tree",
      },
      "alt+2": {
        handler: () => setNewLayout(LeftTab.Assets),
        description: "Switch to Assets",
      },
      "alt+3": {
        handler: () => setNewLayout(LeftTab.Community),
        description: "Switch to Community",
      },
      "alt+4": {
        handler: () => setNewLayout(LeftTab.FileSelector),
        description: "Switch to File Selector",
      },
      "alt+5": {
        handler: () => setNewLayout(LeftTab.Git),
        description: "Switch to Git Settings",
      },
      "alt+6": {
        handler: () => setNewLayout(LeftTab.History),
        description: "Switch to History",
      },
      "alt+7": {
        handler: () => setNewLayout(LeftTab.AppStore),
        description: "Switch to App Store",
      },
      "alt+8": {
        handler: () => setNewLayout(LeftTab.Info),
        description: "Switch to Info",
      },
      "alt+9": {
        handler: () => setNewLayout(LeftTab.ProjectSettings),
        description: "Switch to Project Settings",
      },
    }),
    [setNewLayout],
  );

  useKeyboardShortcuts({ shortcuts });
};
